import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-coaching-focus-item-summary',
    template: ` <div>
            <span class="cmps-coaching-focus-item-summary--label"
                >{{ opportunityLabel }}&nbsp;</span
            >
            <span>{{ opportunity }}</span>
        </div>
        <div>
            <span class="cmps-coaching-focus-item-summary--label"
                >{{ willingnessLabel }}&nbsp;</span
            >
            <span>{{ willingness }}</span>
        </div>
        <div>
            <span class="cmps-coaching-focus-item-summary--label"
                >{{ proficiencyLabel }}&nbsp;</span
            >
            <span>{{ proficiency }}</span>
        </div>`,
    host: {
        class: 'cmps-coaching-focus-item-summary',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsFocusItemSummaryComponent {
    @Input() opportunityLabel: string;
    @Input() opportunity: string;
    @Input() willingnessLabel: string;
    @Input() willingness: string;
    @Input() proficiencyLabel: string;
    @Input() proficiency: string;
}
